import React, { FC } from 'react';
import { ButtonBase } from '@mui/material';

import { Typography } from '../../../../Typography';


export type ItemProps = {
    /** Выбранный элемент из списка */
    selected: number;
    /** Значение для отображения и передачи в onChange.
     * При отображении приводится к виду НН
     */
    value: number;
    /** Функция выбора элемента */
    onChange: (value: number) => void;
    /** Обозначение индекса. Нужно для переключения через tab на первый элемент */
    needTabIndex?: boolean;
};

export const Item: FC<ItemProps> = ({
    value,
    onChange,
    selected,
    needTabIndex,
}) => (
    <Typography
        component={ButtonBase}
        variant='regularBody2'
        fontSize='1.6rem'
        fontWeight='500'
        p={1.5}
        width='3rem'
        height='3rem'
        borderRadius={2}
        textAlign='center'
        onClick={() => onChange(value)}
        tabIndex={needTabIndex ? 0 : -1}
        sx={{
            cursor: 'pointer',

            bgcolor:
                selected === value ? 'general.primary50' : 'grayscale.shade0',
            color:
                selected === value ? 'grayscale.shade0' : 'grayscale.shade100',

            '&:hover, &:focus': {
                bgcolor:
                    selected === value
                        ? 'general.primary60'
                        : 'grayscale.shade10',
            },
        }}
    >
        {`${value}`.padStart(2, '0')}
    </Typography>
);
